
import {getCreditLimits} from '../api/getCreditLimits';
import {setGetCreditLimitsAction} from '../action';

const setGetCreditLimits = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getCreditLimits(params);

            if (data.status === 'success') {
                dispatch(setGetCreditLimitsAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetCreditLimits
}